import { render, staticRenderFns } from "./IpsCard.vue?vue&type=template&id=02116700&"
import script from "./IpsCard.vue?vue&type=script&lang=js&"
export * from "./IpsCard.vue?vue&type=script&lang=js&"
import style0 from "./IpsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports